import * as t from "io-ts"

export const AttachmentSummary = t.type({
    fileName: t.string,
    description: t.string,
    private: t.boolean,
})

export const ListAttachmentSummariesResponse = t.type({
    attachment_summaries: t.array(AttachmentSummary),
})

export type TAttachmentSummary = t.TypeOf<typeof AttachmentSummary>

export type TListAttachmentSummariesResponse = t.TypeOf<
    typeof ListAttachmentSummariesResponse
>
